"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtractStepDefinitions = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const z = require("zod");
const parent_rating_row_1 = require("../../../../PackageStore/parent-rating-row");
const extract_floats_and_ties_types_1 = require("../../../Datatypes/extract-floats-and-ties.types");
const misc_1 = require("../../misc");
exports.ExtractStepDefinitions = {
    ExtractAmrs: {
        type: 'ExtractAmrs',
        displayName: 'Extract absolute maximum ratings',
        inputSchema: z.object({
            datasheetFileId: z.string(),
            manufacturerPartNumber: z.string(),
            signals: sigma_engine_shared_1.SignalSchema.array(),
            modes: sigma_engine_shared_1.ModeBaseSchema.array(),
            sequenceGate: misc_1.sequenceGateSchema,
            parentAmrRows: parent_rating_row_1.ParentRatingRowSchema.array().optional(),
        }),
        outputSchema: z.object({
            boundaries: sigma_engine_shared_1.ComponentBoundarySchema.array(),
        }),
    },
    ExtractOcs: {
        type: 'ExtractOcs',
        displayName: 'Extract operating conditions',
        inputSchema: z.object({
            datasheetFileId: z.string(),
            manufacturerPartNumber: z.string(),
            signals: sigma_engine_shared_1.SignalSchema.array(),
            modes: sigma_engine_shared_1.ModeBaseSchema.array(),
            sequenceGate: misc_1.sequenceGateSchema,
            parentOcRows: parent_rating_row_1.ParentRatingRowSchema.array().optional(),
        }),
        outputSchema: z.object({
            boundaries: sigma_engine_shared_1.ComponentBoundarySchema.array(),
        }),
    },
    ExtractFloatsAndTies: {
        type: 'ExtractFloatsAndTies',
        displayName: 'Extract floats and ties',
        inputSchema: z.object({
            datasheetFileId: z.string(),
            manufacturerPartNumber: z.string(),
            signals: sigma_engine_shared_1.SignalSchema.array(),
            pinout: misc_1.pkgPinoutSchema,
        }),
        outputSchema: z.object({
            floatsAndTies: extract_floats_and_ties_types_1.FloatsAndTiesSchema,
        }),
    },
    ExtractFunctions: {
        type: 'ExtractFunctions',
        displayName: 'Extract functions',
        inputSchema: z.object({
            datasheetFileId: z.string(),
            manufacturerPartNumber: z.string(),
            sigmaModelType: z.string(),
            signals: sigma_engine_shared_1.SignalSchema.array(),
            resources: sigma_engine_shared_1.IComponentResourceSchema.array(),
        }),
        outputSchema: z.object({
            functions: misc_1.pkgFunctionsSchema,
        }),
    },
    ExtractParameters: {
        type: 'ExtractParameters',
        displayName: 'Extract parameters',
        inputSchema: z.object({
            datasheetFileId: z.string(),
            manufacturerPartNumber: z.string(),
            sigmaModelType: z.string(),
            sequenceGate: misc_1.sequenceGateSchema,
        }),
        outputSchema: z.object({
            parameters: misc_1.pkgParametersSchema,
        }),
    },
    ExtractPinout: {
        type: 'ExtractPinout',
        displayName: 'Extract pinout',
        inputSchema: z.object({
            datasheetFileId: z.string(),
            manufacturerPartNumber: z.string(),
            signals: sigma_engine_shared_1.SignalSchema.array(),
        }),
        outputSchema: z.object({
            pinout: misc_1.pkgPinoutSchema,
        }),
    },
    ExtractResources: {
        type: 'ExtractResources',
        displayName: 'Extract resources',
        inputSchema: z.object({
            datasheetFileId: z.string(),
            manufacturerPartNumber: z.string(),
            sequenceGate: misc_1.sequenceGateSchema,
        }),
        outputSchema: z.object({
            resources: sigma_engine_shared_1.IComponentResourceSchema.array(),
        }),
    },
    ExtractSignalDriveModes: {
        type: 'ExtractSignalDriveModes',
        displayName: 'Extract signal drive modes (legacy)',
        inputSchema: z.object({
            datasheetFileId: z.string(),
            manufacturerPartNumber: z.string(),
            signals: sigma_engine_shared_1.SignalSchema.array(),
            modes: sigma_engine_shared_1.ModeBaseSchema.array(),
            sequenceGate: misc_1.sequenceGateSchema,
        }),
        outputSchema: z.object({
            signals: sigma_engine_shared_1.SignalSchema.array().nullable(),
        }),
    },
    ExtractSignals: {
        type: 'ExtractSignals',
        displayName: 'Extract signals',
        inputSchema: z.object({
            datasheetFileId: z.string(),
            manufacturerPartNumber: z.string(),
            sigmaModelType: z.string(),
        }),
        outputSchema: z.object({
            signals: sigma_engine_shared_1.SignalSchema.array(),
        }),
    },
};
//# sourceMappingURL=extract-steps.js.map